import { supabase } from '../../../src/lib/supabase';

export async function aprovarCadastroUc(ucId: number): Promise<void> {
  const { error } = await supabase.rpc('aprovar_cadastro_uc', { p_uc_id: ucId });
  if (error) throw error;
}
